import React, { FC, useCallback, useMemo } from 'react';
import { connect } from 'react-redux';
import { Redirect, Route, withRouter } from 'react-router';
import {
	PERMISSION_NAMES,
	isUserAllowedToAccess,
	isUserManagedBySupplier,
} from '../../utils/AuthUtils';
import { ROLE_TYPES } from '../../utils/DataConstants';
import {
	assetsRestCrudThunksForBuyer,
	assetsRestCrudThunksForSupplier,
} from '../../thunks/assets_thunks';
import OverviewShell from '../overview_shell/OverviewShell';

require('./AssetsOverviewPage.less');

const ASSETS_OVERVIEW_TARGET_COLLECTION = 'assetsIndex';

const AssetsOverviewPage: FC<any> = ({
	history,
	currentUser,
	companyConfig,
	childRoutes,
	userType,
	fetchAssets,
	assets,
}): React.ReactElement => {
	const handleTabChange = useCallback(
		(key) => history.push(`/${userType}/assets/overview/${key}`),
		[history, userType]
	);

	const checkTabActive = useCallback(
		(key) => {
			const pathname = history.location.pathname;
			return pathname.indexOf(key) !== -1;
		},
		[history.location.pathname]
	);

	const templatesVisible = useMemo(
		() =>
			isUserAllowedToAccess(currentUser.userType)(
				PERMISSION_NAMES.MODIFY_ASSET_TYPES,
				companyConfig,
				currentUser.roles
			),
		[companyConfig, currentUser.roles, currentUser.userType]
	);

	const isNotSupplierManaged = useMemo(() => !isUserManagedBySupplier(currentUser), []);

	const tabs = useMemo(
		() => [
			{
				key: 'all',
				name: 'All',
			},
			...(templatesVisible && isNotSupplierManaged
				? [
						{
							key: 'templates/overview',
							name: 'Types',
						},
				  ]
				: []),
			...(isNotSupplierManaged
				? [
						{
							key: 'downtime',
							name: 'Downtime',
						},
				  ]
				: []),
		],
		[templatesVisible]
	);

	return (
		<>
			<Route
				path={`/${userType}/assets/overview`}
				exact={true}
				render={() => (
					<Redirect
						to={{
							pathname: `/${userType}/assets/overview/all`,
						}}
					/>
				)}
			/>
			<OverviewShell
				title="Assets"
				tabs={tabs}
				onTabChange={handleTabChange}
				checkTabActive={checkTabActive}
				childRoutes={childRoutes}
				className="assetsPage"
			/>
		</>
	);
};

const mapStateToProps = (state) => ({
	companyConfig: state.company_config.detail,
	currentUser: state.session.currentUser,
	assets: state.assets,
});

const mapDispatchToProps = (dispatch, ownProps) => ({
	fetchAssets: (
		params,
		targetCollectionName,
		pagination,
		sorting,
		filters,
		addToTargetCollection
	) =>
		dispatch(
			ownProps.userType === ROLE_TYPES.SUPPLIER
				? assetsRestCrudThunksForSupplier.read(
						params,
						targetCollectionName,
						pagination,
						sorting,
						filters,
						addToTargetCollection
				  )
				: assetsRestCrudThunksForBuyer.read(
						params,
						targetCollectionName,
						pagination,
						sorting,
						filters,
						addToTargetCollection
				  )
		),
});

const ComponentWithoutUserType = withRouter(
	connect(mapStateToProps, mapDispatchToProps)(AssetsOverviewPage)
);

export default connect(
	(state) => ({
		userType: (state as any).session.userType,
	}),
	() => ({})
)(ComponentWithoutUserType);
